import { controllerFactory } from "@utils/createController";

export default class extends controllerFactory()({
  targets: {
    input: HTMLInputElement,
    preview: HTMLSpanElement,
    swatch: HTMLLIElement,
  },
}) {
  change() {
    this.previewTarget.style.backgroundColor = this.inputTarget.value;
  }

  closeDialog(event: MouseEvent) {
    const target = event.target as HTMLSpanElement;
    const input = target.previousElementSibling as HTMLInputElement;
    if (input) {
      this.previewTarget.style.backgroundColor = input.value;
    }
  }

  connect() {
    this.change();
  }

  hexToRgba(hex: string): string {
    let c = hex.substring(1).split("");
    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    const v = "0x" + c.join("");
    return (
      "rgba(" + [(v >> 16) & 255, (v >> 8) & 255, v & 255].join(",") + ",1)"
    );
  }

  select(e: MouseEvent) {
    const inputTarget = e.target as HTMLInputElement;
    const selectedColor = inputTarget.value;
    this.inputTarget.value = selectedColor;
    this.previewTarget.style.backgroundColor = this.hexToRgba(selectedColor);
  }

  toggle() {
    const popoverId = this.inputTarget
      .closest("button")
      .getAttribute("popovertarget");
    document.getElementById(popoverId)?.showPopover();
  }
}
